"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TreeSet = _interopRequireDefault(require("../../../../java/util/TreeSet"));

var _CoordinateList = _interopRequireDefault(require("../geom/CoordinateList"));

var _Arrays = _interopRequireDefault(require("../../../../java/util/Arrays"));

var _PointLocation = _interopRequireDefault(require("./PointLocation"));

var _Stack = _interopRequireDefault(require("../../../../java/util/Stack"));

var _Orientation = _interopRequireDefault(require("./Orientation"));

var _CoordinateArrays = _interopRequireDefault(require("../geom/CoordinateArrays"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

var _Comparator = _interopRequireDefault(require("../../../../java/util/Comparator"));

var _UniqueCoordinateArrayFilter = _interopRequireDefault(require("../util/UniqueCoordinateArrayFilter"));

var _Assert = _interopRequireDefault(require("../util/Assert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ConvexHull =
/*#__PURE__*/
function () {
  function ConvexHull() {
    _classCallCheck(this, ConvexHull);

    ConvexHull.constructor_.apply(this, arguments);
  }

  _createClass(ConvexHull, [{
    key: "preSort",
    value: function preSort(pts) {
      var t = null;

      for (var i = 1; i < pts.length; i++) {
        if (pts[i].y < pts[0].y || pts[i].y === pts[0].y && pts[i].x < pts[0].x) {
          t = pts[0];
          pts[0] = pts[i];
          pts[i] = t;
        }
      }

      _Arrays.default.sort(pts, 1, pts.length, new RadialComparator(pts[0]));

      return pts;
    }
  }, {
    key: "computeOctRing",
    value: function computeOctRing(inputPts) {
      var octPts = this.computeOctPts(inputPts);
      var coordList = new _CoordinateList.default();
      coordList.add(octPts, false);

      if (coordList.size() < 3) {
        return null;
      }

      coordList.closeRing();
      return coordList.toCoordinateArray();
    }
  }, {
    key: "lineOrPolygon",
    value: function lineOrPolygon(coordinates) {
      coordinates = this.cleanRing(coordinates);

      if (coordinates.length === 3) {
        return this._geomFactory.createLineString([coordinates[0], coordinates[1]]);
      }

      var linearRing = this._geomFactory.createLinearRing(coordinates);

      return this._geomFactory.createPolygon(linearRing);
    }
  }, {
    key: "cleanRing",
    value: function cleanRing(original) {
      _Assert.default.equals(original[0], original[original.length - 1]);

      var cleanedRing = new _ArrayList.default();
      var previousDistinctCoordinate = null;

      for (var i = 0; i <= original.length - 2; i++) {
        var currentCoordinate = original[i];
        var nextCoordinate = original[i + 1];

        if (currentCoordinate.equals(nextCoordinate)) {
          continue;
        }

        if (previousDistinctCoordinate !== null && this.isBetween(previousDistinctCoordinate, currentCoordinate, nextCoordinate)) {
          continue;
        }

        cleanedRing.add(currentCoordinate);
        previousDistinctCoordinate = currentCoordinate;
      }

      cleanedRing.add(original[original.length - 1]);
      var cleanedRingCoordinates = new Array(cleanedRing.size()).fill(null);
      return cleanedRing.toArray(cleanedRingCoordinates);
    }
  }, {
    key: "isBetween",
    value: function isBetween(c1, c2, c3) {
      if (_Orientation.default.index(c1, c2, c3) !== 0) {
        return false;
      }

      if (c1.x !== c3.x) {
        if (c1.x <= c2.x && c2.x <= c3.x) {
          return true;
        }

        if (c3.x <= c2.x && c2.x <= c1.x) {
          return true;
        }
      }

      if (c1.y !== c3.y) {
        if (c1.y <= c2.y && c2.y <= c3.y) {
          return true;
        }

        if (c3.y <= c2.y && c2.y <= c1.y) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "reduce",
    value: function reduce(inputPts) {
      var polyPts = this.computeOctRing(inputPts);
      if (polyPts === null) return inputPts;
      var reducedSet = new _TreeSet.default();

      for (var i = 0; i < polyPts.length; i++) {
        reducedSet.add(polyPts[i]);
      }

      for (var i = 0; i < inputPts.length; i++) {
        if (!_PointLocation.default.isInRing(inputPts[i], polyPts)) {
          reducedSet.add(inputPts[i]);
        }
      }

      var reducedPts = _CoordinateArrays.default.toCoordinateArray(reducedSet);

      if (reducedPts.length < 3) return this.padArray3(reducedPts);
      return reducedPts;
    }
  }, {
    key: "getConvexHull",
    value: function getConvexHull() {
      if (this._inputPts.length === 0) {
        return this._geomFactory.createGeometryCollection();
      }

      if (this._inputPts.length === 1) {
        return this._geomFactory.createPoint(this._inputPts[0]);
      }

      if (this._inputPts.length === 2) {
        return this._geomFactory.createLineString(this._inputPts);
      }

      var reducedPts = this._inputPts;

      if (this._inputPts.length > 50) {
        reducedPts = this.reduce(this._inputPts);
      }

      var sortedPts = this.preSort(reducedPts);
      var cHS = this.grahamScan(sortedPts);
      var cH = this.toCoordinateArray(cHS);
      return this.lineOrPolygon(cH);
    }
  }, {
    key: "padArray3",
    value: function padArray3(pts) {
      var pad = new Array(3).fill(null);

      for (var i = 0; i < pad.length; i++) {
        if (i < pts.length) {
          pad[i] = pts[i];
        } else pad[i] = pts[0];
      }

      return pad;
    }
  }, {
    key: "computeOctPts",
    value: function computeOctPts(inputPts) {
      var pts = new Array(8).fill(null);

      for (var j = 0; j < pts.length; j++) {
        pts[j] = inputPts[0];
      }

      for (var i = 1; i < inputPts.length; i++) {
        if (inputPts[i].x < pts[0].x) {
          pts[0] = inputPts[i];
        }

        if (inputPts[i].x - inputPts[i].y < pts[1].x - pts[1].y) {
          pts[1] = inputPts[i];
        }

        if (inputPts[i].y > pts[2].y) {
          pts[2] = inputPts[i];
        }

        if (inputPts[i].x + inputPts[i].y > pts[3].x + pts[3].y) {
          pts[3] = inputPts[i];
        }

        if (inputPts[i].x > pts[4].x) {
          pts[4] = inputPts[i];
        }

        if (inputPts[i].x - inputPts[i].y > pts[5].x - pts[5].y) {
          pts[5] = inputPts[i];
        }

        if (inputPts[i].y < pts[6].y) {
          pts[6] = inputPts[i];
        }

        if (inputPts[i].x + inputPts[i].y < pts[7].x + pts[7].y) {
          pts[7] = inputPts[i];
        }
      }

      return pts;
    }
  }, {
    key: "toCoordinateArray",
    value: function toCoordinateArray(stack) {
      var coordinates = new Array(stack.size()).fill(null);

      for (var i = 0; i < stack.size(); i++) {
        var coordinate = stack.get(i);
        coordinates[i] = coordinate;
      }

      return coordinates;
    }
  }, {
    key: "grahamScan",
    value: function grahamScan(c) {
      var p = null;
      var ps = new _Stack.default();
      ps.push(c[0]);
      ps.push(c[1]);
      ps.push(c[2]);

      for (var i = 3; i < c.length; i++) {
        p = ps.pop();

        while (!ps.empty() && _Orientation.default.index(ps.peek(), p, c[i]) > 0) {
          p = ps.pop();
        }

        ps.push(p);
        ps.push(c[i]);
      }

      ps.push(c[0]);
      return ps;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return ConvexHull;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "extractCoordinates",
    value: function extractCoordinates(geom) {
      var filter = new _UniqueCoordinateArrayFilter.default();
      geom.apply(filter);
      return filter.getCoordinates();
    }
  }]);

  return ConvexHull;
}();

exports.default = ConvexHull;

var RadialComparator =
/*#__PURE__*/
function () {
  function RadialComparator() {
    _classCallCheck(this, RadialComparator);

    RadialComparator.constructor_.apply(this, arguments);
  }

  _createClass(RadialComparator, [{
    key: "compare",
    value: function compare(o1, o2) {
      var p1 = o1;
      var p2 = o2;
      return RadialComparator.polarCompare(this._origin, p1, p2);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RadialComparator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Comparator.default];
    }
  }], [{
    key: "polarCompare",
    value: function polarCompare(o, p, q) {
      var dxp = p.x - o.x;
      var dyp = p.y - o.y;
      var dxq = q.x - o.x;
      var dyq = q.y - o.y;

      var orient = _Orientation.default.index(o, p, q);

      if (orient === _Orientation.default.COUNTERCLOCKWISE) return 1;
      if (orient === _Orientation.default.CLOCKWISE) return -1;
      var op = dxp * dxp + dyp * dyp;
      var oq = dxq * dxq + dyq * dyq;

      if (op < oq) {
        return -1;
      }

      if (op > oq) {
        return 1;
      }

      return 0;
    }
  }]);

  return RadialComparator;
}();

RadialComparator.constructor_ = function () {
  this._origin = null;
  var origin = arguments[0];
  this._origin = origin;
};

ConvexHull.RadialComparator = RadialComparator;

ConvexHull.constructor_ = function () {
  this._geomFactory = null;
  this._inputPts = null;

  if (arguments.length === 1) {
    var geometry = arguments[0];
    ConvexHull.constructor_.call(this, ConvexHull.extractCoordinates(geometry), geometry.getFactory());
  } else if (arguments.length === 2) {
    var pts = arguments[0],
        geomFactory = arguments[1];
    this._inputPts = _UniqueCoordinateArrayFilter.default.filterCoordinates(pts);
    this._geomFactory = geomFactory;
  }
};